/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkturough_Visualize_Forest_Focus_ContentInputs */

const en_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`See your focus`)
};

const ar_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شاهد تركيزك`)
};

const de_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehen Sie Ihren Fokus`)
};

const es_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mira tú concentración`)
};

const fr_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visualisez votre concentration`)
};

const it_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guarda la tua concentrazione`)
};

const ja_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`集中の記録を見る`)
};

const ko_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`집중력 확인하기`)
};

const pt_br_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veja seu foco`)
};

const ru_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Просматривайте свою сосредоточенность`)
};

const th_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ดูการโฟกัสของคุณ`)
};

const tr_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odaklanmanı gör`)
};

const zh_cn_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看到专注`)
};

const zh_tw_walkturough_visualize_forest_focus_content = /** @type {(inputs: Walkturough_Visualize_Forest_Focus_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`看到專注`)
};

/**
* | output |
* | --- |
* | "See your focus" |
*
* @param {Walkturough_Visualize_Forest_Focus_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const walkturough_visualize_forest_focus_content = /** @type {((inputs?: Walkturough_Visualize_Forest_Focus_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkturough_Visualize_Forest_Focus_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "ar") return ar_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "de") return de_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "es") return es_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "fr") return fr_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "it") return it_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "ja") return ja_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "ko") return ko_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "pt_br") return pt_br_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "ru") return ru_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "th") return th_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "tr") return tr_walkturough_visualize_forest_focus_content(inputs)
	if (locale === "zh_cn") return zh_cn_walkturough_visualize_forest_focus_content(inputs)
	return zh_tw_walkturough_visualize_forest_focus_content(inputs)
});